__turbopack_context__.v({
  "className": "poppins_6f2ad59-module__oiRPra__className",
});
